import { EventEmitter } from '@angular/core';
import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-reassign-dialog',
  templateUrl: './reassign-dialog.component.html',
  styleUrls: ['./reassign-dialog.component.scss'],
})
export class ReassignDialogComponent implements OnInit {
  reassignSelected = new EventEmitter<any>();
  assignment: any;
  title: string;
  comment: string;

  selectedOption: boolean = true;
  subYes: boolean = false;
  subNo: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ReassignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.assignment = data.assignment;
    this.title = data.title;
  }

  ngOnInit(): void {}

  onOptionChange(event) {
    switch (event.value) {
      case true:
        this.subNo = false;
        break;
      case false:
        this.subYes = false;
        break;
    }
  }

  onRadioClicked = (event) => {
    event.stopPropagation();
  };

  onReassign = () => {
    this.reassignSelected.emit({
      selectedOption: this.selectedOption,
      subOption: this.selectedOption ? this.subYes : this.subNo,
    });
    this.dialogRef.close();
  };

  onCancel = () => {
    this.dialogRef.close();
  };
}
